import internal from './internal'
import internalTemplate from './template'

export default {
  name: 'InternalInternal',
  path: 'Internal',
  meta: {
    label: 'internal',
    auth: 'internal'
  },
  component: {
    name: 'Internal',
    render(c) {
      return c('router-view')
    }
  },
  children: [internal, internalTemplate]
}
